import { type FeatureFlagList } from './types';

/**
 * Feature flag defaults
 */
export const defaultFeatureFlags: FeatureFlagList = {
	'platform-component-visual-refresh': true,
	'navx-full-height-sidebar': false,
	'platform-dst-lozenge-tag-badge-visual-uplifts': false,
	'platform-dst-shape-theme-default': true,
	'platform-dst-motion-uplift-button': true,
	'platform-dst-motion-uplift-list-item': true,
	platform_dst_ads_appswitcher_improvements: true,
};
